import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=ded691ce&scoped=true&"
import script from "./infos.vue?vue&type=script&lang=js&"
export * from "./infos.vue?vue&type=script&lang=js&"
import style0 from "./infos.vue?vue&type=style&index=0&id=ded691ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded691ce",
  null
  
)

export default component.exports